/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Action } from './action';
import { Message } from './message';

export class Tool {

    constructor(
        public name: string,
        public title?: Message | string,
        public icon?: string,
        public action?: Function,
        public actions?: Action[],
        public disabled?: boolean,
        public hidden?: boolean,
        public style?: string,
        public size?: string,
        public customClass?: string
    ) {}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/model/tool.ts